var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-container",style:(_vm.sideStyle)},[_c('div',{staticClass:"count",style:(_vm.mainStyle),attrs:{"primary-color-var":_vm.primaryColorVar}},[_c('div',{staticClass:"data",class:{ 'compact': _vm.compact }},[_c('h1',[_vm._v(_vm._s(_vm.count))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.name))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }